import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button, Radio } from 'react-bootstrap';
import { getYearOptions } from './../services/dateServices'
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/workingexperiences/"

class WerkervaringWijzig extends Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            data: {
                referenceId: '',
                levelId: '',
                company: '',
                customer: '',
                projectType: 0,
                project: '',
                city: '',
                yearInit: '',
                yearEnd: '',
                hours: '',
                projectDescription: '',
                jobDescription: '',
            },
            errors: {},
            references: []
        }
    }

    getWorkingExperienceDetail(id) {
        Api.GetApi(FETCH_URL + id, this.props.history).then(data => {
            if (data !== undefined)
                this.setState({ data: data })

        })
    }
    componentWillMount() {
        this.getWorkingExperienceDetail(this.props.id)
        Api.GetApi("api/references/").then(data => {
            if (data !== undefined) {
                let references = data.references.map((ref, index) => {
                    return (<option value={ref.id}>{ref.firstName + ' ' + ref.middleName + ' ' + ref.lastName}</option>)
                })

                this.setState({ references: references })
            }
        })
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()
        Object.keys(this.state.data).forEach(e => {
            formData.append(e, this.state.data[e])
        })

        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)

        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(response => {
                Api.print(response)
                if (response !== undefined) {
                    Api.print('Response')
                    Api.print(response)
                    var errorsResponse = true
                    Object.keys(response).forEach(e => {
                        if (typeof response[e] !== "object") {
                            errorsResponse = false
                            return
                        }
                    })

                    if (errorsResponse)
                        this.setState({ errors: response });
                    /**else {
                        this.props.handle()
                        this.setState({ errors: {} })
                    }**/
                    else {
                        alert("Werkervaring updated")
                    }
                }

                else {
                    // TODO: Show message OK
                }


            })
    }

    render() {
        let errors = this.state.errors
        return (
            <div>
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="WerkervaringWijzigReferentie">
                        <Col componentClass={ControlLabel} sm={4}>
                            Referentie *
                                </Col>
                        <Col sm={6}>
                            <FormControl type="select" name="referenceId" value={this.state.data.referenceId} componentClass="select" required onChange={this.handleChange}>
                                <option value="">selecteren</option>
                                {this.state.references}
                            </FormControl>
                            {Api.showError(errors, "referenceId")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigNiveau">
                        <Col componentClass={ControlLabel} sm={4}>
                            Niveau *
                                </Col>
                        <Col sm={6}>
                            <FormControl name="levelId" value={this.state.data.levelId} type="text" required onChange={this.handleChange} />
                            {Api.showError(errors, "levelId")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigWerkgever">
                        <Col componentClass={ControlLabel} sm={4}>
                            Werkgever *
                                </Col>
                        <Col sm={6}>
                            <FormControl name="company" value={this.state.data.company} type="text" required onChange={this.handleChange} />
                            {Api.showError(errors, "company")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigOpdrachtgever">
                        <Col componentClass={ControlLabel} sm={4}>
                            Opdrachtgever
                                </Col>
                        <Col sm={6}>
                            <FormControl name="customer" value={this.state.data.customer} type="text" onChange={this.handleChange} />
                            {Api.showError(errors, "customer")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigSoort">
                        <Col componentClass={ControlLabel} sm={4}>
                            Soort project *
                                </Col>
                        <Col sm={6}>
                            <div>
                                <Radio name="projectType" value={0} checked={this.state.data.projectType === 0} onChange={this.handleChange}>project</Radio>
                                {' '}
                                <Radio name="projectType" value={1} checked={this.state.data.projectType === 1} onChange={this.handleChange}>geclusterde opdracht</Radio>
                                {Api.showError(errors, "projectType")}
                            </div>
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigProject">
                        <Col componentClass={ControlLabel} sm={4}>
                            Project
                                </Col>
                        <Col sm={6}>
                            <FormControl name="project" value={this.state.data.project} type="text" onChange={this.handleChange} />
                            {Api.showError(errors, "project")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigLocatie">
                        <Col componentClass={ControlLabel} sm={4}>
                            Locatie
                                </Col>
                        <Col sm={6}>
                            <FormControl name="city" value={this.state.data.city} type="text" onChange={this.handleChange} />
                            {Api.showError(errors, "city")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigJaarVan">
                        <Col componentClass={ControlLabel} sm={4}>
                            Jaar van *
                                </Col>
                        <Col sm={6}>
                            <FormControl name="yearInit" value={this.state.data.yearInit} componentClass="select" required onChange={this.handleChange}>
                                <option value="">selecteren</option>
                                {getYearOptions()}
                            </FormControl>
                            {Api.showError(errors, "yearInit")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigJaarTot">
                        <Col componentClass={ControlLabel} sm={4}>
                            Jaar tot *
                                </Col>
                        <Col sm={6}>
                            <FormControl name="yearEnd" value={this.state.data.yearEnd} componentClass="select" required onChange={this.handleChange}>
                                <option value="">selecteren</option>
                                {getYearOptions()}
                            </FormControl>
                            {Api.showError(errors, "yearEnd")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigUren">
                        <Col componentClass={ControlLabel} sm={4}>
                            Uren *
                                </Col>
                        <Col sm={6}>
                            <FormControl name="hours" value={this.state.data.hours} type="text" required onChange={this.handleChange} />
                            {Api.showError(errors, "hours")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigOmschrijvingProject">
                        <Col componentClass={ControlLabel} sm={4}>
                            Omschrijving project *
                                </Col>
                        <Col sm={6}>
                            <FormControl name="projectDescription" value={this.state.data.projectDescription} componentClass="textarea" rows="5" required onChange={this.handleChange} />
                            {Api.showError(errors, "projectDescription")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigOmschrijvingWerkzaamheden">
                        <Col componentClass={ControlLabel} sm={4}>
                            Omschrijving werkzaamheden *
                                </Col>
                        <Col sm={6}>
                            <FormControl name="jobDescription" value={this.state.data.jobDescription} componentClass="textarea" rows="5" required onChange={this.handleChange} />
                            {Api.showError(errors, "jobDescription")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="WerkervaringWijzigDocument">
                        <Col componentClass={ControlLabel} sm={4}>
                            Document toevoegen
                                </Col>
                        <Col sm={6}>
                            <FormControl type="File" inputRef={input => this.fileInput = input} />
                            {Api.showError(errors, "file")}
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col smOffset={8} sm={2}>
                            <Button type="submit">Wijzig</Button>
                            {Api.showError(errors, "generalError")}
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default WerkervaringWijzig;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Werkervaring/Edit.js